import React, { useState } from 'react';
import { SketchPicker } from 'react-color';
import reactCSS from 'reactcss';

function ExampleColorPickerView({
  paperBg,
  questionColor,
  answerColor,
  stripColor,
  fontType,
  buttonColor
}) {
  return (
    <div>
      <div className=' shadow-lg rounded-lg' style={paperBg}>
        <div className='rounded-t-lg h-4' style={stripColor}></div>
        <div className='px-4 py-6'>
          <div className='grid grid-cols-12 gap-0'>
            <div className='justify-center'>
              <h4 className='text-center' style={questionColor}>
                1.
              </h4>
            </div>
            <div className='col-span-11'>
              <h4 style={questionColor}>
                Tuliskan pertanyaan yang mudah di baca oleh pengguna
              </h4>
            </div>
          </div>
          <div className='grid grid-cols-12 gap-0'>
            <div className='justify-center'>
              <h4 className='text-center'></h4>
            </div>
            <div className='col-span-11'>
              <h5 className='text-gray-400 italic mt-3 mb-3'>-- Jawaban --</h5>
            </div>
          </div>
          <div className='grid grid-cols-12 gap-0 mt-3 mb-3'>
            <div className='justify-center'>
              <h4 className='text-center'></h4>
            </div>
            <div className='justify-center'>
              <h4 className='text-center' style={answerColor}>
                A.
              </h4>
            </div>
            <div className='col-span-10'>
              <h4 style={answerColor}>
                Tuliskan Jawaban yang mudah di baca oleh pengguna
              </h4>
            </div>
          </div>
          <div className='grid grid-cols-12 gap-0 mt-3 mb-3'>
            <div className='justify-center'>
              <h4 className='text-center'></h4>
            </div>
            <div className='justify-center'>
              <h4 className='text-center' style={answerColor}>
                B.
              </h4>
            </div>
            <div className='col-span-10'>
              <h4 style={answerColor}>
                Tuliskan Jawaban yang mudah di baca oleh pengguna
              </h4>
            </div>
          </div>
          <div className='grid grid-cols-12 gap-0 mt-3 mb-3'>
            <div className='justify-center'>
              <h4 className='text-center'></h4>
            </div>
            <div className='justify-center'>
              <h4 className='text-center' style={answerColor}>
                C.
              </h4>
            </div>
            <div className='col-span-10'>
              <h4 style={answerColor}>
                Tuliskan Jawaban yang mudah di baca oleh pengguna
              </h4>
            </div>
          </div>
          <div className='grid grid-cols-12 gap-0 mt-3 mb-3'>
            <div className='justify-center'>
              <h4 className='text-center'></h4>
            </div>
            <div className='justify-center'>
              <h4 className='text-center' style={answerColor}>
                D.
              </h4>
            </div>
            <div className='col-span-10'>
              <h4 style={answerColor}>
                Tuliskan Jawaban yang mudah di baca oleh pengguna
              </h4>
            </div>
          </div>
        </div>
      </div>

      <br />

      <div className=' shadow-lg rounded-lg' style={paperBg}>
        <div className='rounded-t-lg h-4' style={stripColor}></div>
        <div className='px-4 py-6'>
          <div className='grid grid-cols-12 gap-0'>
            <div className='justify-center'>
              <h4 className='text-center' style={questionColor}>
                2.
              </h4>
            </div>
            <div className='col-span-11'>
              <h4 style={questionColor}>
                Tuliskan pertanyaan yang mudah di baca oleh pengguna
              </h4>
            </div>
          </div>
          <div className='grid grid-cols-12 gap-0'>
            <div className='justify-center'>
              <h4 className='text-center'></h4>
            </div>
            <div className='col-span-11'>
              <h5 className='text-gray-400 italic mt-3 mb-3'>-- Jawaban --</h5>
            </div>
          </div>
          <div className='grid grid-cols-12 gap-0 mt-3 mb-3'>
            <div className='justify-center'>
              <h4 className='text-center'></h4>
            </div>
            <div className='justify-center'>
              <h4 className='text-center' style={answerColor}>
                A.
              </h4>
            </div>
            <div className='col-span-10'>
              <h4 style={answerColor}>
                Tuliskan Jawaban yang mudah di baca oleh pengguna
              </h4>
            </div>
          </div>
          <div className='grid grid-cols-12 gap-0 mt-3 mb-3'>
            <div className='justify-center'>
              <h4 className='text-center'></h4>
            </div>
            <div className='justify-center'>
              <h4 className='text-center' style={answerColor}>
                B.
              </h4>
            </div>
            <div className='col-span-10'>
              <h4 style={answerColor}>
                Tuliskan Jawaban yang mudah di baca oleh pengguna
              </h4>
            </div>
          </div>
          <div className='grid grid-cols-12 gap-0 mt-3 mb-3'>
            <div className='justify-center'>
              <h4 className='text-center'></h4>
            </div>
            <div className='justify-center'>
              <h4 className='text-center' style={answerColor}>
                C.
              </h4>
            </div>
            <div className='col-span-10'>
              <h4 style={answerColor}>
                Tuliskan Jawaban yang mudah di baca oleh pengguna
              </h4>
            </div>
          </div>
          <div className='grid grid-cols-12 gap-0 mt-3 mb-3'>
            <div className='justify-center'>
              <h4 className='text-center'></h4>
            </div>
            <div className='justify-center'>
              <h4 className='text-center' style={answerColor}>
                D.
              </h4>
            </div>
            <div className='col-span-10'>
              <h4 style={answerColor}>
                Tuliskan Jawaban yang mudah di baca oleh pengguna
              </h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ExampleColorPickerView;
